import { useState, useEffect } from "react";
import { supabase } from "@/integrations/supabase/client";
import type { MenuItem } from "@/hooks/usePublicMenu";
import { productToMenuItem, WebMenuProduct } from "@/types/webMenu";

export function usePopularItems(restaurantId: string | undefined) {
  const [items, setItems] = useState<MenuItem[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!restaurantId) {
      setItems([]);
      setLoading(false);
      return;
    }

    setLoading(true);
    supabase
      .rpc("get_popular_menu_items", { _restaurant_id: restaurantId })
      .then(({ data }) => {
        const products = (data || []) as unknown as WebMenuProduct[];
        setItems(products.map((p) => productToMenuItem(p, p.categoryId)));
        setLoading(false);
      });
  }, [restaurantId]);

  return { items, loading };
}
